import * as tslib_1 from "tslib";
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
var NugetViewerModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(NugetViewerModalComponent, _super);
    function NugetViewerModalComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This method gets called on delete and close event.
     */
    NugetViewerModalComponent.prototype.onClose = function () {
        this._dialogRef.close();
    };
    return NugetViewerModalComponent;
}(UiModalComponent));
export { NugetViewerModalComponent };
